import React, { useEffect, useState } from 'react';
import BottomSection from '../components/BottomSection';
import CarouselSection from '../components/CarouselSection';
import twinkleColor1 from '../assets/images/twinkle-color-01.png';
import twinkleColor2 from '../assets/images/twinkle-color-02.png';
import twinkleColor3 from '../assets/images/twinkle-color-03.jpg';
import twinkleColor5 from '../assets/images/twinkle-color-05.png';
import twinkleColorLogo from '../assets/images/twinkle-color-logo.png';
import twinkleActivityAccent from '../assets/images/twinkle-color-activity-accent.png';
import twinkleCarousel1 from '../assets/images/twinkle-color-carousel/twinkle-color-carousel-1.png';
import twinkleCarousel2 from '../assets/images/twinkle-color-carousel/twinkle-color-carousel-2.png';
import twinkleCarousel3 from '../assets/images/twinkle-color-carousel/twinkle-color-carousel-3.png';
import twinkleCarousel4 from '../assets/images/twinkle-color-carousel/twinkle-color-carousel-4.png';
import twinkleCarousel5 from '../assets/images/twinkle-color-carousel/twinkle-color-carousel-5.png';
import { useSeo } from '../seo';

const twinkleCarouselSections = [
  { src: twinkleCarousel1, alt: 'Twinkle Color coser 活动展示一' },
  { src: twinkleCarousel2, alt: 'Twinkle Color coser 活动展示二' },
  { src: twinkleCarousel3, alt: 'Twinkle Color coser 活动展示三' },
  { src: twinkleCarousel4, alt: 'Twinkle Color coser 活动展示四' },
  { src: twinkleCarousel5, alt: 'Twinkle Color coser 活动展示五' },
];

const twinkleStoreIntroParagraphs = [
  'TwinkleColor——价探PriceTag品牌',
  '线下实体门店，坐落在人气S类商场精',
  '选大牌中小样，潮流彩妆品牌、迷人香',
  '氛等，为每个人打造不一样的沉浸式美',
  '妆体验。',
];

function TwinkleColorPage() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useSeo('twinkleColor');

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % twinkleCarouselSections.length);
    }, 3200);

    return () => {
      window.clearInterval(intervalId);
    };
  }, []);

  return (
    <main className="brand-page twinkle-color-page">
      <section className="brand-section">
        <img className="brand-section-image" src={twinkleColor1} alt="Twinkle Color 页面展示一" />
      </section>

      <section className="brand-section twinkle-title-section twinkle-image-title-header-section" style={{ marginTop: '-4%' }}>
        <div className="twinkle-title-block">
          <h2>门店形象</h2>
          <p>Store Image</p>
        </div>
      </section>

      <section className="brand-section">
        <img className="brand-section-image" src={twinkleColor2} alt="Twinkle Color 页面展示二" />
      </section>

      <section className="brand-section twinkle-title-section">
        <div className="twinkle-title-block">
          <h2>门店简介</h2>
          <p>Store Introduction</p>
        </div>
      </section>

      <section className="brand-section twinkle-store-intro-section">
        <img className="brand-section-image" src={twinkleColor3} alt="Twinkle Color 页面展示三" />
        <div className="twinkle-store-intro-overlay" style={{ marginTop: '-5%' }}>
          <img className="twinkle-store-intro-logo" src={twinkleColorLogo} alt="Twinkle Color 品牌标识" />
          <div className="twinkle-store-intro-copy">
            {twinkleStoreIntroParagraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>
        </div>
      </section>

      <section className="brand-section twinkle-title-section twinkle-activity-title-section">
        <div className="twinkle-title-block">
          <h2>门店活动</h2>
          <p>Store Event</p>
          <div className="twinkle-title-accent-row">
            <img src={twinkleActivityAccent} alt="" aria-hidden="true" />
            <span>Coser活动图片展示</span>
            <img src={twinkleActivityAccent} alt="" aria-hidden="true" />
          </div>
        </div>
      </section>

      <CarouselSection
        ariaLabel="Twinkle Color coser 活动展示"
        currentIndex={currentIndex}
        onSelect={setCurrentIndex}
        slides={twinkleCarouselSections}
      />

      <section className="brand-section twinkle-title-section twinkle-honors-title-section" style={{ marginTop: '2%' }}>
        <div className="twinkle-title-block">
          <h2>门店荣誉</h2>
          <p>Store Honors</p>
        </div>
      </section>

      <section className="brand-section">
        <img className="brand-section-image" src={twinkleColor5} alt="Twinkle Color 页面展示五" />
      </section>

      <BottomSection />
    </main>
  );
}

export default TwinkleColorPage;
